import * as React from 'react';
import Header from '../components/common/Header';
import Footer from '../components/common/Footer';
import BillingReport from '../components/Admin/AdminReports/BillingReport';
function BillingReportPage() {
    return (
        <>
        <div className="parent-container">
            <div className="container">
                <div className="header-class">
                <Header isVisible={true} buttonsVisible={true} />
                </div>
            <div className="content-class">
                <BillingReport/>
            </div>
            <div className="footer-class">
                <Footer />
            </div>
            </div>
      </div>
            </>
        );
}

export default BillingReportPage;